<template>
  <div class="banner">
    <my-swiper :options="swiperOptions" :slides="slides"></my-swiper>
  </div>
</template>

<script>
import mySwiper from '@/components/mySwiper.vue'
import defaultImg from '@/assets/images/default_activity.jpg'
import { getActivityRecommend } from '@/api/activity'

export default {
  name: 'home-swiper',
  props: {
  },
  data () {
    return {
      swiperOptions: {
        loop: true,
        paginationType: 'bullets'
      },
      slides: []
    }
  },
  components: { mySwiper },
  created () {
    this.getActivities()
  },
  methods: {
    async getActivities () {
      let response = await getActivityRecommend()

      let slides = []
      let len = response.data.length
      while (len--) {
        let activity = response.data[len]
        slides.unshift({
          id: activity.id,
          url: activity.picture_url,
          click: true
        })
      }
      this.slides = slides
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .banner {
    .default_img {
      width: 100%;
      display: block;
    }
  }
</style>
